import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Quiz } from '../models';
import { QuizDto } from '../models/quiz.dto';

@Injectable({
    providedIn: 'root',
})
export class QuizHttpService {
    private readonly httpClient = inject(HttpClient);

    getQuiz(id: string): Observable<Quiz> {
        return this.httpClient.get<QuizDto>(`library/quizzes/${id}`).pipe(
            mapDto((dto) => new Quiz(dto)),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
